import React, { useContext, useState } from "react";
import styles from "./styles/PosServices.module.css";
import DataContext from "../../../context/DataContext";
import AuthContext from "../../../context/AuthContext";
import POSDataContext from "../../../context/POSDataContext";
import { axiosSW } from "../../../api/axiosDefaults";
import useCurrencySymbol from "../../../hooks/useCurrencySymbol";
import { t } from "i18next";
import useAuthReady from "../../../hooks/useAuthReady";
import useNumberFormat from "../../../hooks/useNumberFormat";
/**
 * Service button component for services POS
 */
const ButtonService = ({
    body, // {string} - Button text
    size, // {string} - Size of the button (adapt: adapt to parent font size, standard: 1.5rem)
    serviceId, // {Integer} - Service ID
    price, // {Float} - Price of the service
}) => {
    const {
        connection, // {Object} - Current client's settings
    } = useContext(DataContext);
    const [isProcesseing, setIsProcesseing] = useState(false);
    const {
        incCount, // {Function} - Increments the count of the shopping cart
        handleErrorPos, // {Function} - Handles the error in the POS context
        userLogout,
    } = useContext(POSDataContext);
    const {
        user, // {Object} - Current user
    } = useContext(AuthContext);
    const currency = useCurrencySymbol(true);
    const formatNum = useNumberFormat();

    /**
     * The service button content
     * @param {String} service - The name of the service
     * @param {Float} price -  The price of the service
     * @returns {JSX.Element } - The button content
     */

    const buttonContent = (service, price) => {
        return (
            <span className={`v-flex-container`}>
                <span
                    className={`${styles.button_content_service_name} flex-container`}
                >
                    {service}
                </span>
                <span
                    className={`${styles.button_content_service_price} flex-container`}
                >
                    {`${currency} ${formatNum(price)}`}
                </span>
            </span>
        );
    };

    /**
     * click handle function
     * send API request for the service
     * once the buttn is clicked, it will be disabled for 1 sec
     * @param {Event} event - The event object
     */
    const handleClick = async (event) => {
        event.preventDefault();

        const serviceItems = [
            {
                serviceID: serviceId,
                quantity: 1,
            },
        ];
        const payLoad = {
            uniqueIdentifier: connection?.uniqueIdentifier,
            cartID: user?.cartID,

            serviceCartItems: serviceItems,
        };

        setIsProcesseing(true);
        try {
            const { data } = await axiosSW.post(
                "ShoppingCart/pos/AddShoppingCartItem",
                payLoad,
            );

            if (data?.statusOk) {
                incCount(1);
                // set delay to show the text "Service Added" for 1 second
                setTimeout(() => {
                    setIsProcesseing(false);
                }, 1000);
            }
        } catch (error) {
            if (error?.request?.status === 404) {
                setIsProcesseing(false);
                userLogout();
            } else {
                setIsProcesseing(false);
                handleErrorPos(error);
            }
        }
    };

    return (
        <div className={`${styles.service_button_container}   flex-container`}>
            <button
                className={`${styles.service_button_base} ${
                    size === "adapt" ? styles.adapt : styles.standard
                } ${styles.service_button}   ${
                    isProcesseing ? styles.service_button_disable : ""
                }`}
                onClick={handleClick}
                type={"button"}
                value={body}
                aria-label={`${body} service button`}
                disabled={isProcesseing} // block the button while processing
            >
                {/* change the button text and style while processing */}
                {isProcesseing ? "Service Added" : buttonContent(body, price)}
            </button>
        </div>
    );
};

export default ButtonService;
